export const PAYMENT_REDIRECT = `/api/v1/bill/for-parent`;
